export enum DiscountType {
  Employee = 'Employee',
  Fixed = 'Fixed',
  DiscountCode = 'DiscountCode'
}
